import { COMP_UPLOAD_UI } from "../constants";

export class AddLaterBehaviorComponent {
  constructor(parent) {
    this.parent = parent;
    this.controller = parent.controller;
  }

  async activateSwatchGroup($swatchGroup) {
    const name = $swatchGroup.attr('data-name');
    const side = this.parent.$container.attr('data-side');
    const layer = this.parent.$container.attr('data-layer');
    const $price = this.parent.$container.find('.price');
    const state = this.controller.state;

    if (name === '-add-later-') {
      const uploadComponent = this.parent.components.get(COMP_UPLOAD_UI);
      state.requires_artwork = true;
      const art_url = this.parent.controller.settings.tex_add_later;
      state.custom_art[side] = {
        file_name: "JHaudio-logo-white.svg",
        requires_artwork: true
      };
      await uploadComponent.loadImage(null, art_url, state.custom_art[side].file_name, true)
      const transform = Object.assign({}, state.custom_art[side]);
      // keep transform clean from art url and file info
      if ("file_name" in transform) {
        delete transform.file_name;
      }
      if ("url" in transform) {
        delete transform.url;
      }
      if ("requires_artwork" in transform) {
        delete transform.requires_artwork;
      }
      uploadComponent.updateImageTransform(transform)
    } else {
      // clean up requires_artwork flag when something other than -add-later- is selected.
      if (side in state.custom_art && state.custom_art[side].requires_artwork) {
        delete state.custom_art[side].requires_artwork;
      }
    }
  }

}